/**
 * Created by kz on 28.06.17.
 */
import _ from 'lodash'

export const all = (state) => {
  return _.groupBy(state.participations, 'tender.id')
}

export const current = (state) => {
  return state.current
}



// WEBPACK FOOTER //
// ./src/store/modules/participation/getters.js